<template>
  <div class="static-motion">
    <div class="text-container">
      <div class="text-animation" ref="textAnimation">
        <span v-for="(char, index) in currentText.split('')" :key="index" class="text-char" :ref="`char-${index}`">
          {{ char }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";

export default {
  data() {
    return {
      currentText: "",
      currentAnimationIndex: 0,
      texts: ["Live Master", "直播大师"],
      animations: ["typing", "waveIn"],
      isAnimating: false,
    };
  },
  mounted() {
    this.startAnimationCycle();
  },
  methods: {
    startAnimationCycle() {
      this.animateText(0);
    },
    animateText(textIndex) {
      // Set current text
      this.currentText = this.texts[textIndex];

      this.$nextTick(() => {
        // Get animation for this cycle
        const animationEffect = this.animations[this.currentAnimationIndex];

        // Get all character elements
        const chars = this.$refs.textAnimation.querySelectorAll(".text-char");

        // Reset any existing animations
        anime.remove(chars);

        // Set initial state - all chars invisible
        chars.forEach((char) => {
          char.style.opacity = 0;
        });

        // Apply animation
        const animationConfig = this.getAnimationConfig(animationEffect);

        anime({
          targets: chars,
          ...animationConfig,
          complete: () => {
            // Wait 4 seconds before next animation
            setTimeout(() => {
              // Switch to next animation
              this.currentAnimationIndex = (this.currentAnimationIndex + 1) % this.animations.length;

              // If we've gone through all animations for this text, move to next text
              if (this.currentAnimationIndex === 0) {
                textIndex = (textIndex + 1) % this.texts.length;

                // If we're starting over from the beginning, wait longer
                if (textIndex === 0) {
                  setTimeout(() => {
                    this.animateText(textIndex);
                  }, 4000); // Additional 4s wait when looping back to start (8s total)
                  return;
                }
              }

              this.animateText(textIndex);
            }, 4000);
          },
        });
      });
    },
    getAnimationConfig(effect) {
      switch (effect) {
        case "typing":
          return {
            opacity: [0, 1],
            duration: 50,
            delay: anime.stagger(120),
            easing: "linear",
          };

        case "waveIn":
          return {
            opacity: [0, 1],
            translateY: function (el, i) {
              return i % 2 === 0 ? [20, 0] : [-20, 0];
            },
            scale: [0.8, 1],
            duration: 700,
            delay: anime.stagger(40),
            easing: "easeInOutSine",
          };

        default:
          return {
            opacity: [0, 1],
            duration: 600,
            easing: "linear",
            delay: anime.stagger(30),
          };
      }
    },
  },
};
</script>

<style scoped lang="less">
.static-motion {
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: #504950;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.text-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.text-animation {
  font-size: 80px;
  color: #e0e0e0;
  text-align: center;
  max-width: 80%;
}

.text-char {
  display: inline-block;
  opacity: 0;
  color: #e0e0e0;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .text-animation {
    font-size: 60px;
  }
}
</style>
